let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQMAD")).then(() => parcelRequire('cFlWj'));